export const SUMMARY_TAB = 'summary';
export const SCHEDULE_TAB = 'schedule';
export const SESSIONS_TAB = 'sessions';
export const SPEAKERS_TAB = 'speakers';
export const RECORDINGS_TAB = 'recordings';
export const REGISTRATIONS_TAB = 'registrations';
export const TICKETS_TAB = 'tickets';
export const ACCESS_RULES_TAB = 'rules'; //TODO: Deprecate ACCESS_RULES_TAB when old dashboard is removed
export const PARTICIPANTS_TAB = 'participants';
export const REGISTRATION_FORM_TAB = 'registration-form';
export const STAGE_BACKDROP_TAB = 'backdrop';
export const PRE_RECORDED_VIDEO_TAB = 'video';
export const SESSION_RESOURCES_TAB = 'session-resources';
export const LIVE_STREAM_TAB = 'live-stream';
export const SPONSORS_TAB = 'sponsors';
export const PROMOTIONS_TAB = 'promotions';
export const EMAIL_COMMUNICATIONS_TAB = 'email-communications';
export const PROMOTE_ON_AIRMEET_TAB = 'promote-on-airmeet';
export const SOCIAL_SHARING_LINKS_TAB = 'social-sharing-links';
export const BRANDING_TAB = 'branding';
export const EVENT_BRANDING_TAB = 'event-branding';
export const BOOTHS_TAB = 'booths';
export const VENUE_SETTINGS_TAB = 'venue';
export const RECEPTION_TAB = 'reception';
export const PERFORMANCE_TAB = 'performance';
export const INTEGRATIONS_TAB = 'integrations';
export const ATTENDEE_ENGAGEMENT_TAB = 'attendee-engagement';
export const LEADERBOARD_TAB = 'leaderboard';
export const INTERESTS_TAB = 'interests';
export const PRE_EVENT_ENTRY_TAB = 'pre-event-entry';
export const POST_EVENT_ENTRY_TAB = 'post-event-entry';
export const STREAM_INTO_AIRMEET_TAB = 'stream-into-airmeet';

// Audience tabs
export const AUDIENCE_TAB = 'audience';
export const AUDIENCE_USERS_TAB = 'users';
export const AUDIENCE_SEGMENTS_TAB = 'segments';

// Analytics tabs
export const ANALYTICS_TAB = 'analytics';
export const ANALYTICS_SUMMARY_TAB = 'analytics-summary';
export const ANALYTICS_REGISTRATIONS_TAB = 'registrations';
export const ANALYTICS_ENGAGEMENT_TAB = 'engagement';

// Settings tabs
export const SETTINGS_TAB = 'settings';
export const EVENT_EXPERIENCE_SETTINGS_TAB = 'event-experience-settings';
export const PRE_POST_EVENT_ENTRY_SETTINGS_TAB =
    'pre-post-event-entry-settings';
export const RECORDINGS_SETTINGS_TAB = 'recordings-settings';
export const MISCELLANEOUS_SETTINGS_TAB = 'miscellaneous-settings';
export const OLD_DASHBOARD_TAB = 'old-dashboard-settings';

export const DEFAULT_EVENT_DASHBOARD_TAB = SUMMARY_TAB;
